// Texto aprovado por Gabriel Bonissoni em 13/10/2026 (tarefa #2756). Para mudar o
// texto, edite só este arquivo — a página (index.js) apenas o renderiza.
//
// White label: o mesmo código roda na Onspace e na Empsis (FaleCRM), então nome e
// dados da empresa vêm do .env de cada site (fora do git), nunca fixos aqui:
//   REACT_APP_NAME           nome do produto (título e "Plataforma")
//   REACT_APP_COMPANY_NAME   nome da empresa usado ao longo do texto
//   REACT_APP_LEGAL_NAME     razão social
//   REACT_APP_LEGAL_CNPJ     CNPJ
//   REACT_APP_LEGAL_ADDRESS  endereço da sede (entra como "com sede na ...")
//   REACT_APP_CONTACT_EMAIL  e-mail de contato e suporte
//   REACT_APP_LEGAL_FORUM    cidade/UF do foro
// Variável ausente = o trecho é omitido ou trocado por um genérico. A logo também é
// a de cada site (src/assets/logo.png, fora do git). Mudou o .env, reinicie o front.
const env = process.env;

// Versão gravada no aceite do cadastro (Companies.termsVersion). Mudou o texto?
// Atualize esta data e a "Última atualização" no fim do texto.
export const TERMS_VERSION = "2026-10-13";

const productName = env.REACT_APP_NAME || "Plataforma";
const company = env.REACT_APP_COMPANY_NAME || productName;

const legalParts = [
	env.REACT_APP_LEGAL_NAME,
	env.REACT_APP_LEGAL_CNPJ && `CNPJ ${env.REACT_APP_LEGAL_CNPJ}`,
	env.REACT_APP_LEGAL_ADDRESS && `com sede na ${env.REACT_APP_LEGAL_ADDRESS}`,
]
	.filter(Boolean)
	.join(", ");
const provider = legalParts ? `${legalParts} ("${company}")` : company;

const contactEmail = env.REACT_APP_CONTACT_EMAIL;
const byEmail = contactEmail
	? `pelo e-mail ${contactEmail}`
	: "pelos canais de atendimento informados na Plataforma";
const support = contactEmail
	? `pelo e-mail ${contactEmail} e pelos canais informados na Plataforma`
	: "pelos canais informados na Plataforma";

const forum = env.REACT_APP_LEGAL_FORUM
	? `o foro de ${env.REACT_APP_LEGAL_FORUM}`
	: `o foro da comarca da sede da ${company}`;

const termsText = `
# Termos e Condições de Uso — ${productName}

## 1. Aceitação e partes

1.1. Estes Termos regem o uso do ${productName}, fornecido por ${provider}.

1.2. Quem cria uma conta, em nome próprio ou de uma empresa, é o "Cliente". Ao marcar "Li e aceito" no cadastro, o Cliente declara que leu e concorda com estes Termos e com a Política de Privacidade.

1.3. Quem aceita em nome de uma empresa declara ter poderes para representá-la.

1.4. Quem não concordar com estes Termos não deve usar a Plataforma.

## 2. Definições

| Termo | Significado |
| --- | --- |
| Plataforma | O software ${productName}, acessado pelo navegador ou pelo aplicativo |
| Cliente | A pessoa ou empresa que contrata a Plataforma |
| Usuário | Cada pessoa que o Cliente cadastra para usar a Plataforma, como atendentes e administradores |
| Contato | A pessoa com quem o Cliente conversa pelos canais conectados |
| Conexão | O vínculo entre a Plataforma e um canal de mensagens, como um número de WhatsApp ou uma conta do Instagram |
| Conteúdo | Mensagens, arquivos, contatos, cards e demais dados que o Cliente e seus Usuários inserem ou recebem na Plataforma |

## 3. O serviço

3.1. A ${company} oferece ao Cliente o direito de usar a Plataforma, sem exclusividade e sem transferência de propriedade, enquanto a assinatura estiver ativa.

3.2. A Plataforma reúne atendimento por WhatsApp, Instagram, SMS e e-mail, funil de vendas (Kanban), tarefas, agendamento de mensagens, relatórios e recursos de inteligência artificial. Os recursos disponíveis dependem do plano contratado.

3.3. A ${company} pode melhorar, alterar ou retirar recursos. Quando a mudança reduzir de forma relevante o que o Cliente contratou, ele será avisado com antecedência de 30 dias.

## 4. Cadastro, conta e usuários

4.1. O Cliente deve informar dados verdadeiros e atualizados no cadastro, como nome da empresa, CNPJ, e-mail e telefone.

4.2. Cada Usuário tem login e senha próprios. O Cliente é responsável por guardar essas credenciais e por tudo o que seus Usuários fizerem na Plataforma.

4.3. O Cliente define o que cada Usuário pode ver e fazer, pelos perfis de acesso. A ${company} não responde por acessos que o próprio Cliente liberou.

4.4. Em caso de suspeita de uso indevido da conta, o Cliente deve trocar as senhas e avisar a ${company} ${byEmail}.

## 5. Planos, pagamento e 1º mês grátis

5.1. Cada plano tem um valor mensal e limites de Usuários e Conexões, informados na página de planos no momento da contratação.

5.2. O primeiro mês é grátis. A cobrança do plano escolhido começa no segundo mês e se repete todo mês no cartão cadastrado, processada pelo Mercado Pago.

5.3. Usuários e Conexões extras podem ser contratados à parte. Um aumento de plano ou de extras é cobrado proporcionalmente aos dias restantes do mês e só é liberado depois da confirmação do pagamento. Uma redução vale a partir do mês seguinte.

5.4. Se o pagamento não for confirmado até 3 dias depois do vencimento, o acesso fica restrito à área financeira até a regularização. Os dados do Cliente não são apagados durante esse bloqueio.

5.5. Os valores podem ser reajustados uma vez por ano pelo IPCA, com aviso de pelo menos 30 dias.

5.6. Os valores pagos não são devolvidos por mês já iniciado, salvo o previsto na seção 6 ou na lei.

## 6. Cancelamento e exclusão de conta

6.1. O Cliente pode cancelar a assinatura a qualquer momento, sem multa, pela Plataforma ou ${byEmail}. O acesso continua até o fim do mês já pago.

6.2. Quem cancelar durante o primeiro mês grátis não paga nada.

6.3. Depois do cancelamento, os dados ficam guardados por 30 dias para que o Cliente possa exportá-los. Passado esse prazo, são apagados ou anonimizados.

6.4. A ${company} guarda o que a lei exigir mesmo após a exclusão, como os registros de acesso por 6 meses (Marco Civil da Internet, art. 15) e os dados fiscais.

## 7. Uso permitido e proibido

7.1. O Cliente deve usar a Plataforma apenas para fins lícitos e de acordo com as regras de cada canal conectado.

7.2. É proibido usar a Plataforma para:

- enviar mensagens em massa a quem não autorizou o contato (spam);
- divulgar conteúdo ilegal, enganoso, ofensivo ou que viole direitos de terceiros;
- aplicar golpes, phishing ou cobranças indevidas;
- tentar invadir, copiar ou sobrecarregar a Plataforma;
- revender o acesso sem autorização escrita da ${company}.

7.3. O Cliente é o único responsável pelo Conteúdo que envia e por ter autorização para falar com seus Contatos.

7.4. Se houver violação desta seção, a ${company} pode suspender a conta, avisando o Cliente sempre que possível.

## 8. Serviços de terceiros

8.1. A Plataforma se conecta a serviços de outras empresas, como WhatsApp, Instagram, operadoras de SMS, Mercado Pago e provedores de inteligência artificial. Cada um tem regras próprias, que o Cliente também deve seguir.

8.2. **WhatsApp por QR Code** não é uma integração oficial da Meta. A Meta pode limitar ou banir o número a qualquer momento, e a ${company} não responde por esse bloqueio. Para quem precisa de mais estabilidade, a Plataforma oferece a API oficial do WhatsApp.

8.3. As tarifas que a Meta cobra pelas mensagens da API oficial são cobradas pela própria Plataforma, conforme o contrato de cada Cliente: no cartão de crédito do Cliente ou dentro do plano de assinatura.

8.4. Respostas geradas por inteligência artificial podem conter erros. O Cliente deve configurar e acompanhar os agentes de IA que usar.

8.5. Os dados do cartão são tratados pelo Mercado Pago, conforme as regras dele.

8.6. A ${company} não responde por falhas, mudanças de regra ou interrupções desses serviços de terceiros.

## 9. Dados pessoais e LGPD

9.1. Nos dados dos Contatos, o Cliente é o **controlador** e a ${company} é a **operadora**, nos termos da Lei 13.709/2018 (LGPD). A ${company} trata esses dados apenas para prestar o serviço e seguindo as instruções do Cliente.

9.2. Cabe ao Cliente ter uma base legal para tratar os dados dos Contatos, como consentimento ou execução de contrato, e atender aos pedidos dos titulares.

9.3. A ${company} adota medidas de segurança para proteger os dados, como acesso por senha, controle de permissões e conexão criptografada (HTTPS).

9.4. Se houver um incidente de segurança que afete dados do Cliente, a ${company} avisará o Cliente em até 48 horas depois de tomar conhecimento.

9.5. Os dados do próprio Cliente e de seus Usuários são tratados conforme a Política de Privacidade da ${company}.

## 10. Disponibilidade e suporte

10.1. A ${company} se esforça para manter a Plataforma no ar 24 horas por dia, mas não garante funcionamento sem nenhuma interrupção.

10.2. Manutenções programadas serão feitas, sempre que possível, fora do horário comercial e com aviso prévio.

10.3. O suporte é prestado ${support}.

## 11. Propriedade intelectual

11.1. A Plataforma, sua marca, seu código e seu design pertencem à ${company}. Estes Termos não transferem nenhum desses direitos ao Cliente.

11.2. O Conteúdo inserido pelo Cliente continua sendo dele. O Cliente autoriza a ${company} a usar esse Conteúdo apenas para prestar o serviço.

11.3. Sugestões de melhoria enviadas pelo Cliente podem ser usadas pela ${company} sem nenhum pagamento.

## 12. Limitação de responsabilidade

12.1. A ${company} não responde por lucros cessantes, perda de vendas ou outros danos indiretos ligados ao uso da Plataforma.

12.2. A ${company} não responde por danos causados pelo Conteúdo do Cliente, por bloqueios de canais feitos por terceiros ou por mau uso das credenciais de acesso.

12.3. Em qualquer caso, a responsabilidade total da ${company} fica limitada ao valor pago pelo Cliente nos 12 meses anteriores ao fato.

12.4. Os limites desta seção não se aplicam quando a lei os proibir, como em caso de dolo.

## 13. Alterações, disposições gerais e foro

13.1. A ${company} pode alterar estes Termos. Mudanças relevantes serão avisadas por e-mail ou na Plataforma com pelo menos 30 dias de antecedência. Quem continuar usando a Plataforma depois desse prazo aceita a nova versão.

13.2. Se uma cláusula for considerada inválida, as demais continuam valendo.

13.3. Estes Termos seguem as leis do Brasil.

13.4. Fica eleito ${forum} para resolver qualquer disputa. Quando o Cliente for consumidor, vale o foro do domicílio dele, como prevê o Código de Defesa do Consumidor.

Última atualização: 13/10/2026.
`;

export default termsText;
